package org.ssoft.server.common.msg

import kotlinx.serialization.*
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.*
import kotlinx.serialization.protobuf.*
import tk.mallumo.common.msg.Message
import kotlin.getValue

@OptIn(ExperimentalSerializationApi::class)
val PROTO_INSTANCE_MSG by lazy {
    ProtoBuf {
//        encodeDefaults = true
        serializersModule = SerializersModule {
            polymorphic(Message::class) {

                subclass(Message.DataSend::class, Message.DataSend.serializer())
                subclass(Message.DataReceive::class, Message.DataReceive.serializer())

                subclass(Message.Task::class, Message.Task.serializer())
                subclass(Message.Status::class, Message.Status.serializer())
                subclass(Message.Cmd::class, Message.Cmd.serializer())
                subclass(Message.Screenshot::class, Message.Screenshot.serializer())

                subclass(Message.ReportConnection::class, Message.ReportConnection.serializer())
                subclass(Message.ReportPlaylist::class, Message.ReportPlaylist.serializer())
                subclass(Message.ReportSystem::class, Message.ReportSystem.serializer())
                subclass(Message.ReportApp::class, Message.ReportApp.serializer())

                subclass(Message.ReportGame::class, Message.ReportGame.serializer())
                subclass(Message.GameAction::class, Message.GameAction.serializer())
            }
        }
    }
}

val JSON_INSTANCE_MSG by lazy {
    Json {
        ignoreUnknownKeys = true
        coerceInputValues = true
        encodeDefaults = true
        prettyPrint = false
        isLenient = true
        classDiscriminator = "polymorphic"
        serializersModule = SerializersModule {
            polymorphic(GameReportContent::class) {
                subclass(GameReportContent.Wheel::class, GameReportContent.Wheel.serializer())
            }
        }
    }
}